import { AddCommar, ConvertDateTimeToText, ConvertDateToText, DisplayPaging } from "components/MyControl"
import moment from "moment";
import { useEffect, useState } from "react";

export default function ProfilePackageHistory({ page = 1, size = 10
    , paginate, data
    , handleSizeTableChange
    , handlePagingChange
    , LoadingQtList }) {
    const [pagination, setPagination] = useState({
        page: 1,
        size: 10,
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [QuonationList, setQuontationList] = useState([]);

    useEffect(() => {
        setPagination({
            page: page,
            size: size,
            record_start: paginate.record_start,
            record_end: paginate.record_end,
            record_count: paginate.record_count,
            page_count: paginate.page_count
        });

        setQuontationList(data);
    }, [data, paginate])

    return (

        <div className='mt-3 mb-3'>
            <div className={`border rounded p-4 bg-white shadow w-100`}>
                <h5 className='mb-4 text-start text-blue-01'>ประวัติ</h5>
                <div>
                    <div className="table-responsive border rounded">
                        <table className="table  text-nowrap">
                            <thead className="table-light">
                                <tr>
                                    <th style={{width:'30px'}}>ลำดับที่</th>
                                    <th className='text-start  ' >ใบสั่งซื้อ</th>
                                    <th className='text-center  ' >วันที่ทำใบสั่งซื้อ</th>
                                    <th className='text-center'>วันที่แพ็กเกจ</th>
                                    <th className='text-center ' >แพ็กเกจ</th>
                                    <th className='text-center'>สถานะแพ็กเกจ</th>
                                    <th className='text-start ' >จำนวนเงิน</th>
                                    <th className='text-center ' >วันที่ครบกำหนด</th>
                                    <th className='text-center ' >วันที่ชำระเงิน</th>
                                    <th className='text-center border-end' >สถานะลูกค้า</th>
                                    <th className='text-center' >ใบแจ้งหนี้</th>
                                    <th className='text-center ' >ใบเสร็จรับเงิน</th>
                                    <th className='text-center ' >สถานะเอกสาร</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    LoadingQtList === false &&
                                    QuonationList.map((obj, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{pagination.record_start + index}</td>
                                                <td className='text-start ' width={115}>{obj.quontation_number}</td>
                                                <td className='text-center ' width={120}>{ConvertDateToText(obj.create_date)}</td>
                                                <td className='text-center ' width={200}>{ConvertDateToText(obj.effective_date) + ' - ' + ConvertDateToText(obj.expiry_date)}</td>
                                                <td className='text-start  ' width={100}>{obj.package_master_name_short}</td>
                                                <td className='text-center  ' width={100}>
                                                    {
                                                    (obj.active === true &&  (moment() < moment(obj.effective_date)) ) && <span className="alert d-inline p-0 ps-2 pe-2 alert-warning">Pending</span>
                                                    }
                                                    {
                                                    (obj.active === true &&  (moment() >= moment(obj.effective_date))) && <span className="alert d-inline p-0 ps-2 pe-2 alert-success">Active</span>
                                                    }
                                                    {
                                                    (obj.active === false ) && <span className="alert d-inline  p-0 ps-2 pe-2 alert-danger">Expiry</span>
                                                    }
                                                </td>
                                                <td className='text-end ' width={70}>{AddCommar(obj?.grand_total_sub_withholding_tax?.toFixed(2))}</td>
                                                <td className='text-center ' width={110}>{ (obj.package_type === 'free')? '-' : ConvertDateToText(obj?.due_date)}</td>
                                                <td className='text-center ' width={110}>{ (obj.package_type === 'free')? '-' :ConvertDateToText(obj?.paid_date)}</td>
                                                <td className='text-center border-end' width={200}><pre>{obj.payment_status_name}</pre></td>
                                                <td className='text-center ' width={120}>{obj?.issued_invoice_memo}</td>
                                                <td className='text-center ' width={120}>{obj?.issued_receipt_memo}</td>
                                                <td className='text-center ' width={120}>{obj?.audit_status_name}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <DisplayPaging rec_start={pagination.record_start}
                        rec_end={pagination.record_end}
                        rec_count={pagination.record_count}
                        onSizeChange={handleSizeTableChange}
                        cur_page={pagination.page}
                        size={pagination.size}
                        page_count={pagination.page_count}
                        onPagingChange={handlePagingChange} />
                </div>
            </div>
        </div>

    )
}